import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

function InstagramIconTwoTone(props: SvgIconProps) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="6.731%" y1="93.485%" x2="93.591%" y2="6.619%" id="hoivogl2za">
          <stop stopColor="#FD5" offset="0%" />
          <stop stopColor="#FF543E" offset="50%" />
          <stop stopColor="#C837AB" offset="100%" />
        </linearGradient>
      </defs>
      <g fillRule="nonzero" fill="none">
        <path
          d="M1.304 1.389C-.263 3.016.058 4.745.058 9.997c0 4.362-.76 8.734 3.222 9.763 1.244.32 12.263.32 13.505-.001 1.658-.428 3.007-1.773 3.192-4.118.026-.328.026-10.954-.001-11.288-.196-2.498-1.734-3.938-3.76-4.23-.464-.067-.558-.087-2.94-.091C4.824.036 2.972-.34 1.304 1.389z"
          fill="url(#hoivogl2za)"
        />
        <path
          d="M10.026 2.64c-3.017 0-5.881-.269-6.975 2.54-.452 1.16-.387 2.665-.387 4.822 0 1.893-.06 3.671.387 4.822 1.091 2.81 3.979 2.54 6.973 2.54 2.889 0 5.867.301 6.975-2.54.452-1.172.386-2.655.386-4.822 0-2.876.159-4.733-1.236-6.127-1.413-1.412-3.323-1.235-6.126-1.235h.003zm-.66 1.326c6.292-.01 7.093-.709 6.651 9.009-.157 3.436-2.774 3.06-5.99 3.06-5.866 0-6.034-.169-6.034-6.036 0-5.936.465-6.03 5.373-6.034v.001zm4.59 1.223a.883.883 0 1 0 0 1.766.883.883 0 0 0 0-1.766zm-3.93 1.032a3.78 3.78 0 1 0 .001 7.561 3.78 3.78 0 0 0-.001-7.56zm0 1.327c3.244 0 3.248 4.908 0 4.908-3.244 0-3.249-4.908 0-4.908z"
          fill="#FFF"
        />
      </g>
    </SvgIcon>
  );
}

export default InstagramIconTwoTone;
